import i18n from "src/translations";

/**
 * formatter for signed state cell
 * @param {string} cell the signed status
 */
export function signedFormatter(cell) {
  return cell ? i18n.t(`data.signedState.${cell}`) : "";
}
